module.exports = __webpack_public_path__ + "img/xtdd-title1.52ccabb8.png";